import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import AllCysteinesUpsetPlot from './AllCysteinesUpsetPlot';
import HyperReactiveUpsetPlot from './HyperReactiveUpsetPlot';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`upset-tabpanel-${index}`}
      aria-labelledby={`upset-tab-${index}`}
      {...other}
      style={{ height: '100%' }}
    >
      {value === index && (
        <Box sx={{ height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `upset-tab-${index}`,
    'aria-controls': `upset-tabpanel-${index}`,
  };
}

const Explorer: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          aria-label="cysteine upset plots"
          sx={{ px: 2 }}
        >
          <Tab label="All Cysteines" {...a11yProps(0)} />
          <Tab label="Hyper Reactive Cysteines" {...a11yProps(1)} />
        </Tabs>
      </Paper>
      
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <TabPanel value={value} index={0}>
          <AllCysteinesUpsetPlot />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <HyperReactiveUpsetPlot />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default Explorer;